// import roleBaseMockApi from './roleBaseMockApi';

import { isEmpty } from 'lodash';

// const USE_MOCK = process.env.USE_MOCK === 'true';

export default function useRoleBase(roleBaseData) {
  if (!roleBaseData || isEmpty(roleBaseData)) return {};

  const {
    routes,
    primary_action: primaryAction,
    resources,
  } = roleBaseData?.rolebase ?? {};

  const isPrimaryActionAvailable = (fldName) => primaryAction.indexOf(fldName) !== -1;
  const isRouteAvailable = (fldName) => routes.indexOf(fldName) !== -1;
  const isResourceAvailable = (fldName) => resources.indexOf(fldName) !== -1;

  const isInResource = (resName, propName, fldName) => {
    if (!resName || !propName || !fldName) return false;
    const resource = resources.find((res) => res?.resource_type === resName) ?? {};
    if (!resource?.[propName]) return false;
    return resource[propName].indexOf(fldName) !== -1;
  };
  const isFieldAvailable = (resName, fldName) => isInResource(resName, 'available_fields', fldName);
  const isThreeDotActionAvailable = (resName, fldName) => isInResource(resName, 'available_three_dots_actions', fldName);
  const isFilterAvailable = (resName, fldName) => isInResource(resName, 'available_filters', fldName);
  const isWidgetAvailable = (resName, fldName) => isInResource(resName, 'available_widgets', fldName);

  return {
    availableRoutes: routes,
    availableResources: resources,
    roleBaseFunctions: {
      isFieldAvailable,
      isFilterAvailable,
      isPrimaryActionAvailable,
      isResourceAvailable,
      isRouteAvailable,
      isThreeDotActionAvailable,
      isWidgetAvailable,
    },
  };
}
